module.exports = __webpack_public_path__ + "img/iot-scene-security.f70429bc.png";